import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import axiosRetry from "axios-retry";

import setInterceptors from './interceptors';

const createAxiosInstance = (): AxiosInstance => {
  const config: AxiosRequestConfig = {
    baseURL: process.env.API_URL,
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 10000,
  };

  const axiosInstance: AxiosInstance = axios.create(config);
  axiosRetry(axiosInstance, { retries: 3, retryDelay: axiosRetry.exponentialDelay })

  return setInterceptors(axiosInstance);
};

export default createAxiosInstance();
